import { render, staticRenderFns } from "./tagManagement.vue?vue&type=template&id=1e2ac024&scoped=true"
import script from "./tagManagement.vue?vue&type=script&lang=js"
export * from "./tagManagement.vue?vue&type=script&lang=js"
import style0 from "./tagManagement.vue?vue&type=style&index=0&id=1e2ac024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ac024",
  null
  
)

export default component.exports